export namespace TemplateActions {
  export class Create {
    static readonly type = '[Jupiter] Create Template';

    constructor(public template: any) {}
  }

  export class Update {
    static readonly type = '[Jupiter] Update Template';

    constructor(
      public template: any,
      public silently?: boolean,
    ) {}
  }

  export class UpdateAddForm {
    static readonly type = '[Jupiter] Update Add Form';

    constructor(public fields: any[]) {}
  }

  export class ToggleSummary {
    static readonly type = '[Jupiter] Toggle Summary';

    constructor(public value: boolean) {}
  }
}
